import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function DashboardLayout() {
  return (
    <div className="ds-shell">
      <Sidebar />
      <div className="ds-main">
        <Topbar />
        <div className="ds-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
